import React, { useMemo } from 'react';

import { Button } from 'devextreme-react/button';
import { Tooltip } from 'devextreme-react/tooltip';
import Box, { Item as BoxItem } from 'devextreme-react/box';
import AntLocalization from '../utils/AntLocalization';
import AntProcessingButton from './AntProcessingButton';

export default function AntInfoPanel(props) {
    const infoText = useMemo(() => AntLocalization.translateText(props.text), [props.text]);

    const infoDetails = useMemo(() => {
        if (!Array.isArray(props.infos)) return [];
        return props.infos.map((e) => AntLocalization.translateText(e)).join('\n').split('\n');
    }, [props.infos]);

    const hasDetails = infoDetails.length > 0;
    const infoId = props.id;

    if (!infoText) return null;

    return (
        <div className="ant-info-pannel">
            <Box direction="row" height="100%" width="100%">
                <BoxItem baseSize={40}>
                    <Button
                        className="ant-grid-icon ant-icon-info"
                        id={infoId}
                        type="normal"
                        stylingMode="text"
                        focusStateEnabled={false}
                        hoverStateEnabled={false}
                        activeStateEnabled={false}
                    >
                        <i className="dx-icon dx-icon-info" />
                    </Button>
                </BoxItem>

                <BoxItem ratio={1}>
                    <span className="ant-info-text">{infoText}</span>
                </BoxItem>

                {props.showYes && (
                    <BoxItem baseSize={110}>
                        <AntProcessingButton
                            actionId={infoId}
                            stylingMode="text"
                            text={AntLocalization.translateText({ vi: 'Đồng Ý', en: 'Agree', fr: 'Accepter', es: 'Aceptar', id: 'Setuju', ja: '同意', zh: '同意', ko: '동의', hi: 'सहमत', ar: 'موافق' })}
                            onClick={props.onAgreeClick}
                        />
                    </BoxItem>
                )}
            </Box>

            {hasDetails && (
                <Tooltip
                    target={`#${infoId}`}
                    className="ant-tooltip"
                    hideEvent="mouseleave"
                    showEvent={{
                        name: 'mouseenter dxclick keyup'
                    }}
                    hideOnOutsideClick={true}
                >
                    {infoDetails.map((item, key) => (
                        <React.Fragment key={key}>
                            <label>{item}</label>
                            {key < infoDetails.length - 1 && <br />}
                        </React.Fragment>
                    ))}
                </Tooltip>
            )}
        </div>
    );
}
